import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardClearFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 6H9C8.45 6 8 5.55 8 5V3C8 2.45 8.45 2 9 2H15C15.55 2 16 2.45 16 3V5C16 5.55 15.55 6 15 6ZM6.8 4H5C4.45 4 4 4.45 4 5V21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21V5C20 4.45 19.55 4 19 4H17.2V5C17.2 6.21274 16.2127 7.2 15 7.2H9C7.78726 7.2 6.8 6.21274 6.8 5V4ZM8.57568 16.5757L11.1514 13.9999L8.57568 11.4242L9.42421 10.5757L11.9999 13.1514L14.5757 10.5757L15.4242 11.4242L12.8485 13.9999L15.4242 16.5757L14.5757 17.4242L11.9999 14.8485L9.42421 17.4242L8.57568 16.5757Z",
		fill: "currentColor"
	})
});
export default SvgClipboardClearFilled;
